import React, { Component } from "react";
import Dashboard from "../../containers/Dashboard";
import CommToolContext from "../../containers/common/comm_tool_context";
import {withRouter} from "react-router-dom";
class CreatorAdmin extends Component {
  state = {};
  render() {
    return (
      <CommToolContext.Consumer>
        {context => (
          <React.Fragment>
            <Dashboard {...this.props}/>
          </React.Fragment>
        )}
      </CommToolContext.Consumer>
    );
  }
}
CreatorAdmin.contextType = CommToolContext;
export default withRouter(CreatorAdmin);
